
import {formatNumber} from "@/utils/format";
import {killfeed} from "..";

export default function StatsTable()
{
    return (
        <div className="flex flex-col gap-5 flex-wrap justify-center w-full">
            <DeathsTable />
            <UniqueTable />
        </div>
    );
}

function DeathsTable()
{
    const logCount = killfeed.logs.length;
    const pvpLogCount = killfeed.logs.filter(({pvp}) => pvp).length;
    const pvpLogPercentage = Math.round(100 / logCount * pvpLogCount);
    const pveLogCount = logCount - pvpLogCount;
    const pveLogPercentage = Math.round(100 - pvpLogPercentage);

    return (
        <div className="rounded overflow-hidden border">
            <table className="w-full">
                <thead>
                    <tr className="border-b">
                        <th className="p-1.5 h-10 bg-neutral-900" colSpan={2}>Deaths</th>
                    </tr>
                </thead>
                <tbody>
                    <tr className="hover:bg-neutral-900/50 border-b">
                        <th className="p-1.5">PvP</th>
                        <td className="p-1.5 border-l text-center">{formatNumber(pvpLogCount)} ({pvpLogPercentage}%)</td>
                    </tr>
                    <tr className="hover:bg-neutral-900/50 border-b">
                        <th className="p-1.5">PvE</th>
                        <td className="p-1.5 border-l text-center">{formatNumber(pveLogCount)} ({pveLogPercentage}%)</td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr className="hover:bg-neutral-900/50">
                        <th className="p-1.5">Total</th>
                        <td className="p-1.5 border-l text-center">{formatNumber(logCount)}</td>
                    </tr>
                </tfoot>
            </table>
        </div>
    );
}

function UniqueTable()
{
    const playerCount = killfeed.playerNames.length - 1;
    const weaponCount = killfeed.weaponNames.length - 1;
    const objectCount = killfeed.objectNames.length - 1;

    return (
        <div>
            <div className="rounded overflow-hidden border">
                <table className="w-full">
                    <thead>
                        <tr className="border-b">
                            <th className="p-1.5 h-10 bg-neutral-900" colSpan={2}>Unique</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr className="hover:bg-neutral-900/50 border-b">
                            <th className="p-1.5">Player names</th>
                            <td className="p-1.5 border-l text-center">{formatNumber(playerCount)}</td>
                        </tr>
                        <tr className="hover:bg-neutral-900/50 border-b">
                            <th className="p-1.5">Killing tools</th>
                            <td className="p-1.5 border-l text-center">{formatNumber(weaponCount)}</td>
                        </tr>
                        <tr className="hover:bg-neutral-900/50">
                            <th className="p-1.5">Other shit people died to</th>
                            <td className="p-1.5 border-l text-center">{formatNumber(objectCount)}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
}
